import React, { useRef, useState } from "react";
import Autosuggest from "react-autosuggest";
import LoadingOverlay from "react-loading-overlay";

import {
  NEW_PRINT,
  SERVER_URL,
  USE_OVERLAY,
} from "../config/config";
import "./MarfatiyaWise.css";
import "./AutoSuggest.css";

import { dataObject, validate } from "../config/OutstandingPartywiseConfig";
import { crossingOutApiConfig } from "../config/apiConfig.js";
import getLoggedinFyear from "../utils/getLoggedinFyear";
import useForm from "./useForm";

function DailyDSRReport({ sessionObject }) {
  const fyearObj = getLoggedinFyear(sessionObject);

  const variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    branch_account_name: sessionObject.sessionVariables.branch_account_name,
    branch_account_id: String(sessionObject.sessionVariables.branch_account_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
    date_from: fyearObj.start_fyear,
    date_to: fyearObj.end_fyear,
  };

  const [loading, setLoading] = useState(false);
  const reportResponseRef = useRef(null);
  const downloadBtnRef = useRef(null);

  const myForm = useForm(
    "DSRReport",
    validate,
    { ...dataObject, ...variablesFromSession },
    crossingOutApiConfig
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    myForm.setPageState((prev) => ({ ...prev, [name]: value }));
  };

  const buildPayload = (consignor_name) => ({
    paginate: { number_of_rows: 100, page_number: 1 },
    sort_fields: [],
    filter_fields: {
      companyId: String(sessionObject.sessionVariables.company_id || "1"),
      fyear: fyearObj.fyear,
      consignor_name,
    },
    date_dict: {
      date_from: new Date(myForm.pageState.date_from).toISOString(),
      date_to: new Date(myForm.pageState.date_to).toISOString(),
    },
  });

  const fetchReportData = async (consignor_name) => {
    const payload = buildPayload(consignor_name);
    try {
      setLoading(true);
      const res = await fetch(`${SERVER_URL}/report/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      reportResponseRef.current = result;

    } catch (err) {
      console.error("Error fetching report data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadXLS = async () => {
    const reportData = reportResponseRef.current;
    if (!reportData || !reportData.data?.length) {
      alert("No report data found. Please fetch report first.");
      return;
    }

    const payload = {
      client_name: "jkl",
      file_name: "idemitsu_lube_india",
      data: {
        table_data: reportData.data.map((row, index) => ({
          ...row,
          sr_no: index + 1,
        })),
      },
    };

    try {
      setLoading(true);
      const res = await fetch(`${NEW_PRINT}/bilty/download_excel_sheet`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to download XLS");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${myForm.pageState.consignor_name || "report"}.xls`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setTimeout(() => window.location.reload(), 500);
    } catch (err) {
      console.error("Download error:", err);
      alert("Failed to download XLS.");
    } finally {
      setLoading(false);
    }
  };

  const stationToFieldInfo = {
    label: "Consignor Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignor_name",
    type: "text",
    apiConfigKey: "getConsignorSuggestions",
    url: SERVER_URL + "/consignor/",
    suggestionKeyword: "consignor_name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    suggestionSchema: {
      consignor_name: "consignor_name",
      consignor_gst: "consignor_gst",
      consignor_id: "consignor_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: { Enter: "print_button" },
    idClearanceNeeded: "consignor_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: { pay_type: "same" },
  };

  return (
    <div className="page-marfatiya-wise">
      <div className="mr-form-container">
        {USE_OVERLAY && (
          <LoadingOverlay
            active={myForm.overlay || loading}
            spinner
            text="Loading your content..."
          />
        )}
        <div className="form-header">Daily DSR Report</div>
        <div className="form-marfatiya-wise">
          {["date_from", "date_to"].map((field, idx) => (
            <div className="form-row" key={field}>
              <label className="form-label">
                {field.replace("_", " ").toUpperCase()}:
              </label>
              <input
                className="form-input"
                type="date"
                name={field}
                value={myForm.pageState[field]}
                onChange={handleChange}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    myForm.makeFocusOnParticularField(
                      idx === 0 ? "date_to" : "consignor_name"
                    );
                  }
                }}
                ref={(el) =>
                  myForm.storeInputReferenceForSelect(el, field)
                }
              />
            </div>
          ))}

          <div className="form-row">
            <label className="form-label">Consignor Name</label>
            <Autosuggest
              id={stationToFieldInfo.name}
              suggestions={myForm.suggestions ?? []}
              onSuggestionsFetchRequested={(a) =>
                myForm.onSuggestionsFetchRequested(a, (b) =>
                  myForm.suggestionFetchApi(stationToFieldInfo, b)
                )
              }
              onSuggestionsClearRequested={() =>
                myForm.onSuggestionsClearRequested(stationToFieldInfo)
              }
              getSuggestionValue={(suggestion) =>
                suggestion[stationToFieldInfo.suggestionKeyword]
              }
              onSuggestionSelected={(e, { suggestion }) => {
                myForm.getSuggestionValue(
                  suggestion,
                  stationToFieldInfo,
                  myForm.performSuggestions,
                  myForm.updatePageStateForGetSuggestion
                );
                fetchReportData(suggestion.consignor_name);
              }}
              renderSuggestion={(a) =>
                myForm.renderSuggestion(a, stationToFieldInfo)
              }
              highlightFirstSuggestion={true}
              inputProps={{
                ref: (el) => myForm.storeInputReferenceForSelect(el, "consignor_name"),
                value: myForm.pageState[stationToFieldInfo.name] || "",
                onChange: (a, b) =>
                  myForm.onChangeAutoSuggest(a, b, stationToFieldInfo),
                onBlur: () =>
                  stationToFieldInfo.toValidate &&
                  myForm.onblurValidator(stationToFieldInfo),
                onKeyPress: (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    downloadBtnRef.current?.focus();
                  }
                  // myForm.onKeyPressForKeyNav(e, stationToFieldInfo);
                },
                  
              }}
            />
          </div>

          <button 
            className="btn btn-primary" 
            ref={downloadBtnRef}
            onClick={handleDownloadXLS}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleDownloadXLS();
              }
            }}
            disabled={!reportResponseRef.current?.data?.length}
          >
            Download as XLS
          </button>
        </div>
      </div>
    </div>
  );
}

export default DailyDSRReport;
